import { useEffect, useLayoutEffect, useState, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { beginLoading, getLoadingCount, subscribeLoading } from '@/lib/loadingProgress';
import './top-loading-bar.css';

export function LoadingFallback() {
  useLayoutEffect(() => beginLoading(), []);
  return <div role="status" className="p-6 text-sm text-muted-foreground">Loading?</div>;
}

export default function TopLoadingBar() {
  const pending = useSyncExternalStore(subscribeLoading, getLoadingCount, () => 0);
  const location = useLocation();
  const [visible, setVisible] = useState(pending > 0);
  useLayoutEffect(() => {
    const finish = beginLoading();
    let second;
    const first = requestAnimationFrame(() => { second = requestAnimationFrame(finish); });
    return () => { cancelAnimationFrame(first); cancelAnimationFrame(second); finish(); };
  }, [location.key]);
  useEffect(() => {
    if (pending) { setVisible(true); return; }
    const timer = setTimeout(() => setVisible(false), 180);
    return () => clearTimeout(timer);
  }, [pending]);
  if (!visible) return null;
  return <div className="sep-loading-bar" role="progressbar" aria-label="Loading" aria-busy="true"><span /></div>;
}
